import { axiosClient, type IResponse } from '~/common/js/axios';
import type { AxiosRequestConfig } from 'axios';
import { ConversationType } from "@rongcloud/engine";
import { useP2pStore } from '~/store/p2p';
// import PayMessage from '~/pages/p2p/trading-detail/components/im/pay-message.vue';
// import renderComponentToHtml from '~/utils/renderComponent';

export interface getToken_POST_res_type {
 /** undefined */ 
 token: string 
 /** undefined */ 
 targetId: string 
}

/**
* 获取im token
*/
export function getToken_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getToken_POST_res_type>>({
    url: '/gw-api/p2p-im/p2p/im/v1/getToken',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export function getIMTargetInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getToken_POST_res_type>>({
    url: '/gw-api/p2p-im/p2p/im/getTargetInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

// function 
/**
 * make sure on client
 * @returns 
 */
function makeAvatar(name?:string, color?:string){
  if(!process.client || !document){
    console.error("canvas: Error to make im-avatar");
    return;
  }
  const size = 60; // 60*60px

  let canvas = document.createElement('canvas');
  canvas.height = size;
  canvas.width = size;
  const context = canvas.getContext('2d');

  if(!context){
    console.log("canvas: cant get context");
    return ;
  }
  const centerX = size / 2;
  // const centerY = height / 2;
  const radius = size / 2;
  context.beginPath();
  context.arc(centerX, centerX, radius, 0, 2 * Math.PI, false);
  context.fillStyle = color??'#697175';
  context.fill();
  context.closePath();

  // 在圆的中间绘制一个字母
  context.fillStyle = 'white';
  context.font = 'bold 30px IBM';
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  
  const char = name ? name[0]?.toUpperCase(): '/';
  context.fillText(char, centerX, centerX+1.75); // char
  // debugger
  // 将 canvas 转换为 base64 图片
  const url =  canvas.toDataURL('image/png');
  canvas.remove();
  canvas = null;
  // console.log("canvas url:",url);
  return url;
}

/**
 * 用户头像
 */
export const customService = {
  getUserProfile: async (id) => {
    const p2pStore = useP2pStore();
    let userInfo = p2pStore.$state.userInfo;
    if (!p2pStore.userInfo) {
      userInfo = await p2pStore.getP2pUserInfo();
    }
    // 根据用户 id 获取用户信息，包括昵称，手机号，头像等
    return Promise.resolve({
      id: id,
      displayName: userInfo?.nickName,
      name: userInfo?.nickName, //  "data:image/webp;base64"
      portraitUri: makeAvatar(userInfo?.nickName, userInfo?.bgColor)
    });
  },
  // 获取会话详情
  // (会话 targetId 和会话类型 conversationType ) - 包括头像，会话(单聊和群聊)名称，群组头像
  getConversationProfile: (conversations) => {
    const promises = [];
    const p2pStore = useP2pStore();
    let userInfo = p2pStore.tradeUserInfo;
    if(!userInfo){
      conversations.forEach(item=>{

      });
      // p2pStore.getTradeUserInfo();
      // userInfo = //
    }
    // console.log("conversations should be one\n",conversations);

    conversations.forEach((conversation) => {
      const cid = conversation.targetId?.split('_')[0];
      
      let param = {
        ...conversation,
        name: userInfo?.nickName, //conversation.targetId,
        portraitUri: makeAvatar(userInfo?.nickName||'', userInfo?.bgColor),//R.image("60x60"),
      };
      if(userInfo && String(userInfo?.cid) === cid){

        promises.push(
          Promise.resolve(param)
        );
      }else{
        const promise = p2pStore.getTradeUserInfo(Number(cid)).then(info => {
          return {
            ...conversation,
            name: info?.nickName,
            portraitUri: makeAvatar(info?.nickName||'', info?.bgColor),
          };
        });
        promises.push(promise);
      }
    });
    return Promise.all(promises);
  },
};

// const getDiv = ()=>{
//   const mydiv = renderComponentToHtml(PayMessage, {accountInfo:content}).then(html => {
//     console.log(html);
//     return html;
//     // 这里可以对生成的 HTML 进行进一步的处理
//   });
//   return mydiv;
// }

/**
 * 格式化自定义消息（账户信息）
 */
export const messageService = {
  userMessage:{
      'kit:account':(message: any)=>{
        // console.log("text:",message);
        return `<div class="text-message-body"> ${message?.content?.title}</div>`;
      },
      'BM:AccountMsg': (message: any) => {
        // console.log("账户信息（支付方式卡片）message：", message);
        let content;
        let nuxtapp = useNuxtApp();
        // console.log(nuxtapp.i18n);

        const title = nuxtapp.i18n?.global.t('p2p.trading-detail.receiving_account');
        const subtitle = nuxtapp.i18n?.global.t('p2p.trading-detail.payment_method');

        // console.log(title, subtitle);

        try {
          content = JSON.parse(message.content?.content);
          content = content.accountInfo;
        } catch (error) {
          console.error("JSON.parse im-message");
        }
        // const mydiv = renderComponentToHtml(PayMessage, {accountInfo:content}).then(html => {
        //   console.log(html);
        //   return html;
        // });
        const titleDiv = `<div style="color: #1a1b1f; font-size:16px; font-weight: 500;">${title||''}</div>`;
        
        const itemLabel = (label:string, value:string)=>`<div style="margin-top:16px; color: #6a7c81;">${label}</div><div style="color: #1a1b1f;margin-top:4px;word-break: break-all">${value}</div>`;
        const payItems = content?.payFieldList?.map((item:any)=> itemLabel(item.name, item.value))?.join('');
        const firstValue = `<div style="display: flex;align-items: center;">
        <i style="width: 2px;height: 8px;display:inline-block; margin-right:4px; background: ${content.bgColor};"></i>
        <div style="word-break: break-all">${content.payMethod}</div>
        <div style="margin-left: 4px; font-size:10px; color: #13c2c2; border-radius:2px; padding: 1px 4px; background: #13c2c21a;flex-shrink: 0;">${content.currency}</div></div>`;
        const listDiv = `<div style="font-size:14px; line-height: 18.2px;">${itemLabel(subtitle||'', firstValue)}${payItems}</div>`;
        
        return `<div class="text-message-body" style="padding: 16px">${titleDiv}${listDiv}</div>`;
      }
  },
    // 通知类不带头像
    notifyMessage: {
      'BM:CardMsg': (message) => {
        // extra为 应该展示这条消息的用户cid； target为当前用户的对话方cid；
        // 对话方cid等于extra时 即 当前用户cid
        if(message.content.extra === message.targetId){
          return null;
        }
        
        let content = message.content?.content;
        if(content.indexOf('{"')!= -1){
          content = JSON.parse(content);
        }
        // 空消息
        if(!content && (!content.title || !content.message)){
          return null;
        }
        const titleDiv = content.title?
          `<div style="font-size:16px; font-weight:500;line-height: 20px; color:#1A1B1F">${content.title}</div>`:'';
        const textDiv = content?.message?
          `<div style="font-size:12px; line-height: 15.6px; color: #6A7C81;">${content.message}</div>`: '';
        
        const string = `<div class="text-message-body" style="background: #f7fafc; border-radius:8px; text-align: left; padding: 12px 16px;"> ${titleDiv}${textDiv} </div>`;
        return string;
      },
      'kit:demo': (message) => {
        // console.log("=====Evanna: 通知类消息", message);
        const content = message.content;
        const string = `<div class="text-message-body">来自 ${content.name} 的好友请求</div>`;
        return string;
      }
    },
    // 会话最后一条消息展示
    lastMessage:{
      'BM:CardMsg': (message) => {
        // const content = message.content;
        return `[账户信息]`;
      },
      'kit:demo': (message) => {
        // const content = message.content
        const string = `[不带头像好友请求]`;
        return string;
      }
    }
};

export const conversationService = {
  // 过滤会话 false / true
  interceptConversation: conversation => {
    if (!conversation) return true;

    // 系统会话 - 匹配过滤
    if (conversation?.conversationType === ConversationType.SYSTEM) {
      return false;
    }

    // 正常会话 - 不过滤
    return false;
  },

  // 过滤消息 false / true
  interceptMessage: message => {
    if (!message) return true;

    // 系统消息 - 匹配过滤
    if (message?.conversationType === ConversationType.SYSTEM) {
      return false;
    }

    // 正常消息 - 不过滤
    return false;
  }
};

export const customDisplayMessage = {
  
  willSendMessage : (messageBody, conversationType, targetId, messageType) => {
    // 以文本消息为测试
    // console.info('消息发送前回调：', messageBody, conversationType, targetId, messageType)
    return messageBody;
  },
  willDisplayMessages : (message, conversationType, targetId, messageType) => {
    // console.info('消息接收前回调:',message, conversationType, targetId, messageType)
    // 以文本消息为测试
    if(messageType === 'BM:CardMsg'){
      if(String(message.extra) === String(targetId)){
        // console.log("extra === targetId");
      }
    }
    // message.content = message.content.replace('加密发送','')
    return message;
  },
  willDisplayConversationMessage : (message, conversationType, targetId, messageType) => {
    // console.info('会话 lastmessage 展示前回调:',message, conversationType, targetId, messageType)
    // 以文本消息为测试
    // if(messageType == 'RC:TxtMsg')
    // message.content = message.content.replace('加密发送','')
    return message;
  }
  
};